import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  DASHBOARD,
  ALL_BOOKINGS,
  TASKS_STATUS
} from "../../utils/ConstantLinks";
import './style.scss'
import { SelectedUserContext } from "../../context/selecteduser.context";
import { isEmpty } from "lodash";
import { AddLeadActiveIconSvg, AddLeadIconSvg, AllBookingsActiveIconSvg, AllBookingsIconSvg, DashboardActiveIconSvg, DashboardIconSvg, PendingTasksSideNavbarActiveIconSvg, PendingTasksSideNavbarIconSvg } from "../../assets/svg";

interface SidebarProps {
  hide: boolean;
  // other props if any
} 
const Sidebar: React.FC<SidebarProps> = ({hide}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { stepNumber } = useParams();
  const {selectedUser, handleSelectedUser, existingEnquiry, handleExistingEnquiry} = useContext(SelectedUserContext)
  const [activeMenuItem, setActiveMenuItem] = useState<string>("linkA");

  const menuItems = [
    {
      id: "linkA",
      label: "Dashboard",
      path: DASHBOARD,
      icon: <DashboardIconSvg/>,
      activeIcon: <DashboardActiveIconSvg/>,
    },
    {
      id: "linkB",
      label: "Add Lead",
      path: '/add-leads',
      icon: <AddLeadIconSvg/>,
      activeIcon: <AddLeadActiveIconSvg/>,
    },
    {
      id: "linkC",
      label: "All Bookings",
      path: ALL_BOOKINGS,
      icon: <AllBookingsIconSvg/>,
      activeIcon: <AllBookingsActiveIconSvg/>,
    },
    // {
    //   id: "linkD",
    //   label: "Pending Tasks",
    //   path: TASKS_STATUS,
    //   icon: <PendingTasksSideNavbarIconSvg/>,
    //   activeIcon: <PendingTasksSideNavbarActiveIconSvg/>,
    // },
  ]

  const onItemClick = (item: any) => (event: any) => {
    setActiveMenuItem(item.id);
  };

  const redirection = (item: any) => {
    if(item?.id === "linkB" && !!stepNumber) return location.pathname
    else return item?.path
  }

  useEffect(() => {
    menuItems?.map((item) => {
      if (location.pathname.startsWith(item?.path)) setActiveMenuItem(item.id);
    });
    //temp reset context state handle
    if (!isEmpty(existingEnquiry) && !location.pathname.startsWith('/add-leads')) handleExistingEnquiry({});
    if (!!selectedUser?.email && !location.pathname.startsWith('/add-leads'))
    handleSelectedUser({ email: "", firstName: "", lastName: "", phoneNumber: "", whatsappNumber: "", accountSource: "" });
  }, [location.pathname]);

  return (
    <div className="bg-white mt-[60px] h-100 side-navbar-link-wrapper">
      <div className="flex flex-col gap-2 mx-3">
        {menuItems?.map((item) => (
          <div
            id={item?.id}
            onClick={() => navigate(redirection(item))}
            className={`${item?.id === activeMenuItem ? "text-white font-semibold" : ""}
            ${item?.id !== activeMenuItem ? "hover:bg-[#f3f3f3]" : ""}
             rounded-lg no-underline text-secondary-dark text-sm cursor-pointer`}
            style={{
              background:item?.id=== activeMenuItem? "linear-gradient(305.75deg, #92278f -144.06%, #ec7765 147.18%)":""
            }}
            key={item?.id}
          >
            <div className="flex gap-x-3 py-[12px] px-3 items-center" onClick={onItemClick(item)}>
              {item?.id === activeMenuItem ? item?.activeIcon : item?.icon}
              {!hide&& <span className="leading-7">{item?.label}</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
